export default {
  edit: "product:edit",
  create: "product:create",
  delete: "product:delete",
  view: "product:view",
};
